<template>
    <div class="search-user">
        <button @click="openModal('invite-users-to-project')" class="btn btn-default btn-search-user">
            <i class="fa fa-user-plus"></i> Invite ATT
        </button>
        <modal id="invite-users-to-project" size="lg">
            <template slot="title">Search ATTs</template>
            <template slot="body">
                <field-input v-model="query" @input="search" placeholder="Name or Certified Number..." :with-placeholder="true" class="search-input"></field-input>
                <div class="results">
                    <table class="table table-striped table-sm">
                        <tbody>
                            <tr is="work-team-user"
                                v-for="user in users"
                                :key="user.id" :user="user"
                                :project="project"
                                :version="version"
                                @invited="invitedUser"></tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <template slot="footer">
                <a href="#" @click="closeModal('invite-users-to-project')">Close</a>
            </template>
        </modal>
    </div>
</template>
<script>
    export default {

        props:{
            project:{
                type: Object,
                required: true,
            },
            version:{
            }
        },

        data () {
            return {
                users: [],
                query: '',
            }
        },

        created(){
            this.search()
        },

        methods: {

            search() {
                $('#modal-body').scrollTop = 0;
                App.request().post(`/projects/${this.project.slug}/work-team/search`, {
                    query: this.query
                }).then(response => {
                    this.users = response.data
                })
            },

            invitedUser(user) {
                this.search();
                this.$emit('invited', user);
                this.users.splice(this.users.indexOf(user), 1);
                this.closeModal('invite-users-to-project');
            }
        }
    }
</script>
